"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _teaComponent = require("@tencent/tea-component");
var _excluded = ["className", "style", "children", "customize", "responsive", "placement"];
var MobileDialog = function MobileDialog(props) {
  var className = props.className,
    style = props.style,
    children = props.children,
    customize = props.customize,
    _props$responsive = props.responsive,
    responsive = _props$responsive === void 0 ? true : _props$responsive,
    placement = props.placement,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("mobile-dialog");
  var classes = (0, _classnames2.default)(prefixCls, className, {
    responsive: responsive
  }, {
    'is-customize': customize
  }, (0, _defineProperty2.default)({}, "placement-".concat(placement), !!placement && placement != 'default'));
  return /*#__PURE__*/_react.default.createElement(_teaComponent.Modal, (0, _extends2.default)({
    className: classes,
    maskClosable: true
  }, extraProps), children);
};
var _default = MobileDialog;
exports.default = _default;